import { Component, OnInit } from '@angular/core';
import { FormControl, FormBuilder } from '@angular/forms';
import { Router } from '@angular/router'; // AJOUTÉ : Pour la navigation manuelle
import { filter, debounceTime, distinctUntilChanged, switchMap, tap } from 'rxjs/operators';

// Services
import { SearchService } from '@services/search.service';
import { ProductService } from '@services/product.service';
import { GlobalService } from '@services/global.service';
import { RouteService } from '@services/route.service';

// Modèles
import { ProductFilter } from '@models/filter';
import { Product, SCateg } from '@models/product';
import { environment } from '@environments/environment';
import { Gamme } from 'src/app/models/product';

@Component({
  selector: 'app-search-bar',
  templateUrl: './search-bar.component.html',
  styleUrls: ['./search-bar.component.scss']
})
export class SearchBarComponent implements OnInit {

  loading: boolean = false;
  text: FormControl;

  // Résultats
  products: Product[] = [];
  scategs: SCateg[] = [];
  scategSelected: SCateg[] = [];
  gammes: Gamme[] = [];
  gammeSelected: Gamme[] = [];

  // Affichage
  showResults: boolean = false;

  constructor(
    public search: SearchService,
    private fb: FormBuilder,
    private pServ: ProductService,
    private gServ: GlobalService,
    public route: RouteService,
    private router: Router // Injection du Router Angular
  ) {
    this.text = fb.control('');

    // Chargement des catégories pour la recherche locale
    this.gServ.getSCategs().subscribe((scategs: SCateg[]) => this.scategs = scategs);
    // Load 'gamme' filter
    this.gServ.getGammes().subscribe((gammes: Gamme[]) => this.gammes = gammes);

    this.text.valueChanges
      .pipe(
        // Si moins de 3 caractères, on ferme et on arrête tout
        tap(val => {
          if (!val || val.length < 2) {
            this.showResults = false;
            this.loading = false;
          }
        }),
        filter(query => query && query.length >= 2), // On filtre APRES le tap
        debounceTime(400),
        distinctUntilChanged(),
        switchMap(value => {
          this.loading = true;
          this.showResults = true; // On ouvre la liste dès qu'on commence à chercher

          // 0. Search 'gammes'
          this.gammeSelected = this.searchGammes(value);

          // 1. Recherche locale catégories
          this.scategSelected = this.searchSCategs(value);

          // 2. Recherche API produits
          let filter: ProductFilter = new ProductFilter();
          filter.fullname = value;
          filter.scoring = true;

          return this.pServ.searchProducts(filter, 0, 24);
        })
      )
      .subscribe((products: Product[]) => {
        this.loading = false;
        this.products = products.slice(0, 10);
      });
  }

  ngOnInit(): void {}

  // --- ACTIONS ---

  // Déclenché par le bouton Loupe ou la touche Entrée
  searchGlobal() {
    if (this.text.value && this.text.value.length > 0) {
      this.closeResults();
      const url = this.route.parse('product-search', [this.text.value]);
      this.router.navigateByUrl(url);
    }
  }

  closeResults() {
    this.showResults = false;
  }

  // --- LOGIQUE MÉTIER ---

  searchSCategs(search: string) {
    search = this.formatSearch(search.toLowerCase());
    return this.scategs
      .filter(scateg => this.formatSearch(scateg.name.toLowerCase()).includes(search))
      .slice(0, 3);
  }

  searchGammes(search: string) {
    search = this.formatSearch(search.toLowerCase());
    return this.gammes
      .filter(gamme => this.formatSearch(gamme.name.toLowerCase()).includes(search))
      .slice(0, 3);
  }

  formatSearch(search: string) {
    const accents: any = /[éèêëÉÈÊËáàâäÁÀÂÄíìîïÍÌÎÏóòôöÓÒÔÖúùûüÚÙÛÜçÇ]/g;
    const accentsMap: any = {
        'é': 'e', 'è': 'e', 'ê': 'e', 'ë': 'e', 'É': 'E', 'È': 'E', 'Ê': 'E', 'Ë': 'E',
        'á': 'a', 'à': 'a', 'â': 'a', 'ä': 'a', 'Á': 'A', 'À': 'A', 'Â': 'A', 'Ä': 'A',
        'í': 'i', 'ì': 'i', 'î': 'i', 'ï': 'i', 'Í': 'I', 'Ì': 'I', 'Î': 'I', 'Ï': 'I',
        'ó': 'o', 'ò': 'o', 'ô': 'o', 'ö': 'o', 'Ó': 'O', 'Ò': 'O', 'Ô': 'O', 'Ö': 'O',
        'ú': 'u', 'ù': 'u', 'û': 'u', 'ü': 'u', 'Ú': 'U', 'Ù': 'U', 'Û': 'U', 'Ü': 'U',
        'ç': 'c', 'Ç': 'C'
    };
    return search.replace(accents, match => accentsMap[match] || match);
  }

  getImage(product: Product) {
    if (product.cover)
      return `${environment.imgUrl}/product/${product.cover}`;

    if (product.mainImage === null || !product.mainImage)
      return `assets/img/logo/logo.png`;

    return `${environment.imgUrl}/product/${product.mainImage.name}`;
  }
}
